import React from 'react';
import classNames from 'classnames';

import { ComponentColor } from './types';

export const Divider = ({ children, color }: DividerProps): React.JSX.Element => {
    const dividerClasses = classNames(
        'divider',
        color === ComponentColor.Accent ? 'divider-accent' : '',
        color === ComponentColor.Error ? 'divider-error' : '',
        color === ComponentColor.Ghost ? 'divider-ghost' : '',
        color === ComponentColor.Info ? 'divider-info' : '',
        color === ComponentColor.Neutral ? 'divider-neutral' : '',
        color === ComponentColor.Primary ? 'divider-primary' : '',
        color === ComponentColor.Secondary ? 'divider-secondary' : '',
        color === ComponentColor.Success ? 'divider-success' : '',
        color === ComponentColor.Warning ? 'divider-warning' : ''
    );

    return (
        <div>
            <div className={dividerClasses}>{children}</div>
        </div>
    );
};

interface DividerProps {
    children?: React.ReactNode;
    color?: ComponentColor;
}

export default Divider;
